import axios from 'axios';

const axiosClient = axios.create({
  baseURL: `${process.env.REACT_APP_API}`,
  headers: {
    'Content-type': 'application/json',
  },
  withCredentials: true,
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (err) => {
    console.log(err);
  }
);

export const handleAxiosError = (error) => {
  if (axios.isAxiosError(error)) {
    const serverError = error;
    if (serverError && serverError.response) {
      return serverError.response.data;
    }
  }
};

export default axiosClient;
